import { render, staticRenderFns } from "./templateBlank.vue?vue&type=template&id=3ff075ca&scoped=true"
import script from "./templateBlank.vue?vue&type=script&lang=ts"
export * from "./templateBlank.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff075ca",
  null
  
)

export default component.exports